import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const InfoIcon = memo(() => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill="currentColor"
        // eslint-disable-next-line max-len
        d="M11.65 16.35h.7V11h-.7v5.35Zm.35-6.6c.142 0 .26-.048.356-.144a.484.484 0 0 0 .144-.356.484.484 0 0 0-.144-.356A.484.484 0 0 0 12 8.75a.484.484 0 0 0-.356.144.484.484 0 0 0-.144.356c0 .142.048.26.144.356A.484.484 0 0 0 12 9.75Zm.004 10.95a8.482 8.482 0 0 1-3.393-.685 8.795 8.795 0 0 1-2.764-1.858 8.78 8.78 0 0 1-1.861-2.761 8.458 8.458 0 0 1-.686-3.392c0-1.202.228-2.334.685-3.393a8.793 8.793 0 0 1 1.858-2.764 8.78 8.78 0 0 1 2.761-1.861 8.458 8.458 0 0 1 3.392-.686c1.203 0 2.334.228 3.393.685a8.793 8.793 0 0 1 2.764 1.859 8.781 8.781 0 0 1 1.861 2.76 8.458 8.458 0 0 1 .686 3.392 8.482 8.482 0 0 1-.685 3.393 8.793 8.793 0 0 1-1.858 2.764 8.781 8.781 0 0 1-2.761 1.861 8.458 8.458 0 0 1-3.392.686ZM12 20c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z"
      />
    </svg>
  </IconWrapper>
));
